/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEggCuteFi: {
  name: 'egg-cute-fi';
  data: string;
} = {
  name: 'egg-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.463 2.041c-.634.1-1.457.44-2.083.861C7.467 4.185 5.66 6.721 4.734 9.42c-.988 2.881-.968 5.651.059 7.966.967 2.183 2.84 3.777 5.107 4.348.717.181 1.254.243 2.1.243s1.383-.062 2.1-.243c2.31-.582 4.182-2.2 5.152-4.454.514-1.197.727-2.325.723-3.84a10.2 10.2 0 0 0-.278-2.509c-.867-3.875-3.569-7.608-6.265-8.652-.564-.219-1.428-.323-1.969-.238"/></svg>`
};
